export const ActiveInd = {
    Y:"Y",
    N:"N",
}